import { responseSchema } from './response-schema';
export var makeRequestConfig = function (_a) {
    var endpoint = _a.endpoint, appNamespace = _a.appNamespace, noRetry = _a.noRetry, browserCacheParams = _a.browserCacheParams;
    return {
        endpoint: endpoint,
        body: {
            method: 'getMainMenu',
            params: {
                scope: appNamespace,
            },
        },
        responseSchema: responseSchema,
        isErrorTextStraightToOutput: true,
        retry: noRetry ? 0 : 2,
        ignoreResponseIdCompare: true,
        notRetryWhenOffline: true,
        browserCacheParams: browserCacheParams,
    };
};
